import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobileXs() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.xs)
    });
}